import React from 'react'
import { Container, Grid, Col, Text, Paper } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const ElectronicAttendancePolicy = () => {
  const { lang } = useTranslation()
  return (
    <>
      {lang === 'en' ? (
        <Container size="lg">
          <Grid>
            <Col span={12}>
              <>
                <Text size="lg" weight={700} style={{ marginBottom: '1rem' }}>
                  Electronic Attendance Policy
                </Text>
                <Text style={{ marginBottom: '1rem' }}>
                  Electronic attendance is considered one of the foundations of
                  learner success through e-learning and distance education.
                  Synchronous electronic presence refers to the virtual presence
                  of the trainee connected to the Internet on the virtual
                  platform through a computer or mobile device.
                </Text>
                <Text size="lg" weight={700} style={{ marginBottom: '1rem' }}>
                  The Most Important Electronic Attendance Policies
                </Text>
                <ol
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 0px 0px 40px',
                  }}
                >
                  <li>
                    <Text>
                      Management Follow-up and Supervision:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          The center’s management undertakes the process of
                          following up, supervising, and monitoring the
                          trainees’ access to the electronic platform.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      Monitor and Record Attendance and Absence Electronically:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          The attendance and absence of trainees in lectures are
                          automatically monitored and recorded electronically
                          via virtual classroom systems.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      Informing Trainees of the Attendance Rate:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          Trainees are informed of the percentage of electronic
                          attendance on the virtual platform.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      The Trainee’s Commitment to the Required Rate:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          The trainee acknowledges during registration that they
                          must achieve the percentage required to obtain the
                          certificate and the hours of education.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      Consequences of Non-compliance with Attendance:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          The trainee’s failure to comply with the minimum
                          percentage of the “electronic attendance” system (not
                          less than 25%) will result in them being considered
                          not to have attended the entire training program and
                          being deprived of the certificate.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      Minimum Hours of Concurrent Attendance:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          The trainee must achieve a minimum of 25% concurrent
                          attendance hours.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      Equating Virtual Attendance with Regular Attendance:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          Virtual attendance is considered equivalent to regular
                          attendance.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      Blended Learning:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          If the education is blended, the same percentage is
                          calculated whether attendance is virtual or regular.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      The Number Allowed in Virtual Classes:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          The allowed number in simultaneous virtual classes in
                          higher education is 35 learners.
                        </li>
                        <li>
                          The number of learners is allowed to increase by 25%
                          over the above-mentioned number in the synchronous
                          virtual class, based on:
                        </li>
                        <ul
                          style={{
                            listStyle: 'inherit',
                            // margin: '16px 0px',
                            padding: '0px 0px 0px 40px',
                          }}
                        >
                          <li>Course type</li>
                          <li>Activities and interaction</li>
                          <li>
                            The faculty member’s experience in providing
                            e-learning
                          </li>
                        </ul>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      Academy Commitment:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          The Infinity Health Training Academy Center pledges
                          not to exceed the permitted number of learners in
                          simultaneous virtual classes, in order to ensure the
                          quality of education and optimal interaction between
                          trainees and trainers.
                        </li>
                      </ul>
                    </Text>
                  </li>
                </ol>
              </>
            </Col>
          </Grid>
        </Container>
      ) : (
        <Container size="lg">
          <Grid>
            <Col span={12}>
              <>
                <Text size="lg" weight={700} style={{ marginBottom: '1rem' }}>
                  سياسة الحضور الإلكتروني
                </Text>
                <Text style={{ marginBottom: '1rem' }}>
                  يُعتبر الحضور الإلكتروني من أسس نجاح المتعلم عبر التعلم
                  الإلكتروني والتعليم عن بُعد. يشير الحضور الإلكتروني المتزامن
                  إلى التواجد افتراضياً للمتدرب المتصل بالإنترنت على المنصة
                  الافتراضية من خلال جهاز حاسوب أو جهاز محمول.
                </Text>
                <Text size="lg" weight={700} style={{ marginBottom: '1rem' }}>
                  أهم سياسات الحضور الإلكتروني
                </Text>
                <ol
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 40px 0px 0px',
                  }}
                >
                  <li>
                    <Text>
                      متابعة وإشراف الإدارة:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          تتولى إدارة المركز عملية المتابعة والإشراف والرصد
                          لدخول المتدربين على المنصة الإلكترونية.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      رصد وتسجيل الحضور والغياب إلكترونيًا:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          يتم رصد وتسجيل الحضور والغياب إلكترونيًا للمتدربين في
                          المحاضرات عبر أنظمة الفصول الافتراضية بشكل آلي.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      إعلام المتدربين بنسبة الحضور:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          يُعلم المتدربين بنسبة الحضور الإلكتروني على المنصة
                          الافتراضية.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      التزام المتدرب بالنسبة المطلوبة:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          يُقر المتدرب أثناء التسجيل أنه يجب عليه تحقيق النسبة
                          المطلوبة للحصول على الشهادة وساعات التعليم.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      عواقب عدم الالتزام بالحضور:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          يؤدي عدم التزام المتدرب بالحد الأدنى من نسب نظام
                          "الحضور الإلكتروني" (بما لا يقل عن 25%) إلى اعتباره لم
                          يحضر كامل البرنامج التدريبي وحرمانه من الشهادة.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      الحد الأدنى من ساعات الحضور المتزامن:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          يجب أن يحقق المتدرب الحد الأدنى من تقديم ساعات الحضور
                          المتزامن بما لا يقل عن 25%.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      معادلة الحضور الافتراضي بالحضور الاعتيادي:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          يُعتبر الحضور الافتراضي معادلاً للحضور الاعتيادي.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      التعليم المدمج:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          في حال كان التعليم مدمجًا، تُحسب النسبة ذاتها سواء كان
                          الحضور افتراضيًا أو اعتياديًا.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      العدد المسموح به في الفصول الافتراضية:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          العدد المسموح به في الفصول الافتراضية المتزامنة في
                          التعليم العالي هو 35 متعلمًا.
                        </li>
                        <li>
                          يُسمح بزيادة عدد المتعلمين بمقدار 25% على العدد
                          المذكور أعلاه في الفصل الافتراضي المتزامن، بناءً على:
                        </li>
                        <ul
                          style={{
                            listStyle: 'inherit',
                            // margin: '16px 0px',
                            padding: '0px 40px 0px 0px',
                          }}
                        >
                          <li>نوع المقرر</li>
                          <li>الأنشطة والتفاعل</li>
                          <li>
                            خبرة عضو هيئة التدريس في تقديم التعليم الإلكتروني
                          </li>
                        </ul>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      التزام الأكاديمية:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          يتعهد مركز أكاديمية إنفينيتي للتدريب الصحي بعدم تجاوز
                          العدد المسموح به للمتعلمين في الفصول الافتراضية
                          المتزامنة، وذلك لضمان جودة التعليم والتفاعل الأمثل بين
                          المتدربين والمدربين.
                        </li>
                      </ul>
                    </Text>
                  </li>
                </ol>
              </>
            </Col>
          </Grid>
        </Container>
      )}
    </>
  )
}

export default ElectronicAttendancePolicy
